<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="7" class="px-10 text-center">
                    <h1 class="mb-5">Listen & Learn</h1>
                    <p> 
                        Stronger associations listen to their members. With Yabbr Surveys, associations can capture feedback, tailor services, and keep a pulse on what matters most.
                    </p>
                    <div class="d-flex justify-center"><hr/></div>
                </v-col>
            </v-row>
            <v-row cols="12" justify="center" class="mb-5" v-for="row in rows" :key="row[0].icon">
                <v-col cols="12" md="2" class="d-flex flex-column align-center justify-center" v-for="col in row" :key="col">
                    <v-icon color="primary" style="box-shadow: 0 0 5px 5px lightgrey; border-radius: 100%; padding: 20px;" class="mb-5" size="40px">mdi-{{ col.icon }}</v-icon>
                    <h1 class="text-h6">{{ col.text }}</h1>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsWizard',
    data: () => ({
        rows: [
            [
                {
                    icon: 'calendar-check',
                    text: 'Event satisfaction surveys'
                },
                {
                    icon: 'chart-bar',
                    text: 'Member feedback polls'
                }
            ],
            [
                {
                    icon: 'sitemap',
                    text: 'Interest/skill mapping'
                },
                {
                    icon: 'phone-in-talk',
                    text: 'Policy consultation'
                }
            ]
        ]
    })
}
</script>

<style lang="scss">


hr {
    margin: 1em 0;
    width: 50%;
}
</style>